<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('homework.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homework.pageTitle'),
            href: '/homeworks'
          },
          {
            text: $t('homework.comment'),
            active: true
          }
        ]"
      />
    </div>

    <div class="row">
      <div class="col-md-12 form-group">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form class="form-horizontal">
                <br />
                <br />
                <br />
                <br />
                <div
                  class="ts-border ts-rounded ts-border-blue-200 ts-border-opacity-20 ts-p-3"
                >
                  <teacher-profile :profile="teacherProfile" />
                  <br />
                  <br />
                  <homework-info :info="homework_resource" />
                </div>
                <br />
                <h1 class="ts-py-2">{{ $t('homework.referenceVideo') }}</h1>
                <div
                  class="ts-border ts-rounded ts-border-blue-200 ts-border-opacity-20 ts-p-3"
                >
                  <div class="row">
                    <div
                      v-for="(refer, index) in referenceVideo"
                      :key="index"
                      class="col-md-4"
                      :class="{ 'form-group': referenceVideo.length > 3 }"
                    >
                      <iframe
                        v-if="refer.url"
                        width="100%"
                        height="250px"
                        :src="
                          'https://www.youtube.com/embed/' + videoId(refer.url)
                        "
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <!-- <div class="col-md-4 form-group">
        <ts-card>
          <div class="loading" v-if="loading_comment"></div>
          <ts-card-wrapper>
            <a
              href="#"
              v-if="current_page !== last_page"
              @click.prevent="fetchComment"
              >{{ $t('homework.viewMoreComment') }}</a
            >
            <ul ref="container" id="container">
              <li v-for="comment in resources" :key="comment.id" class="mt-2">
                <display-comment class="mb-2" :record="comment" />
                <ul class="border-reply">
                  <li v-for="co in comment.children" :key="co.id">
                    <display-comment
                      class="mb-2"
                      width="30px"
                      height="30px"
                      :record="co"
                    />
                  </li>
                  <li>
                    <input-public-comment
                      class="mt-2"
                      width="30px"
                      height="30px"
                      v-if="comment.is_reply"
                      :referenceId="comment.id"
                    />
                  </li>
                </ul>
              </li>
            </ul>
            <input-public-comment class="mt-2" />
          </ts-card-wrapper>
        </ts-card>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TeacherProfile from './component/teacher-profile'
import HomeworkInfo from './component/homework-info'
import InputPublicComment from './component/input-comment'
import DisplayComment from './component/display-comment'

export default {
  name: 'homeworkComment',
  components: {
    TeacherProfile,
    HomeworkInfo,
    InputPublicComment,
    DisplayComment
  },
  data() {
    return {
      loading_comment: false,
      loading: false,
      homework_resource: {},
      manPhoto: require('../../../../assets/staff-default-man.png'),
      womenPhoto: require('../../../../assets/staff-default-women.png'),
      referenceVideo: []
    }
  },
  computed: {
    ...mapState('eschool/homeworkCommentPublic', [
      'resources',
      'total_comment',
      'current_page',
      'last_page'
    ]),
    teacherProfile() {
      return this.homework_resource.teacher
        ? this.homework_resource.teacher.photo
        : ''
    }
  },
  created() {
    this.fetchData()
    this.fetchComment()
  },
  methods: {
    fetchComment() {
      this.loading_comment = true
      this.$store
        .dispatch(
          'eschool/homeworkCommentPublic/getComment',
          this.$route.params.id
        )
        .then(response => {
          this.loading_comment = false
          // this.scrollToEnd()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading_comment = false
        })
    },
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('eschool/homeworkCommentPublic/fetch', this.$route.params.id)
        .then(response => {
          this.loading = false
          this.homework_resource = response.data
          this.referenceVideo = JSON.parse(this.homework_resource.url_reference)
            ? JSON.parse(this.homework_resource.url_reference)
            : []
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    videoId(url) {
      return url
        ? url.split('be/')[1]
          ? url.split('be/')[1]
          : url
              .split('?v=')[1]
              .split('&t')[0]
              .split('&list')[0]
              .split('&start_radio')[0]
        : ''
    },
    scrollToEnd() {
      var content = this.$refs.container
      content.scrollTop = content.scrollHeight
    }
  },
  watch: {
    // resources: {
    //   handler() {
    //     this.scrollToEnd()
    //   },
    //   deep: true
    // }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('eschool/homeworkCommentPublic/RESET_STATE')
    next()
  }
}
</script>

<style lang="css" scoped>
ul > li > ul {
  margin-left: 40px;
}
.border-reply {
  /* margin-top: -8px; */
  border-left: 1px solid #eaeaea;
  border-bottom-left-radius: 12px;
}
.loading {
  background: #3491e3;
  height: 3px;
  width: 100%;
  animation: pulse 1s ease infinite alternate,
    nudge 1s ease-out infinite alternate;
}
#container {
  max-height: 75vh;
  overflow: scroll;
}

@keyframes pulse {
  0% {
    background-color: #ffffff;
  }
  100% {
    background-color: #3491e3;
  }
}

@keyframes nudge {
  0% {
    transform: translate(100%, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
}
</style>
